import script from "./ExtendedScoresSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./ExtendedScoresSummary.vue?vue&type=script&setup=true&lang=js"

import "./ExtendedScoresSummary.vue?vue&type=style&index=0&id=797bef6a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-797bef6a"]])

export default __exports__